import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import HighlighterWorker from '@snipit/core/workers/highlighter.worker.js?worker';

// Create a single worker instance to avoid spawning multiple workers 
// which could crash the Chrome Extension side panel due to memory limits.
const worker = new HighlighterWorker();

const AsyncCodeBlock = ({ code, type, className }) => {
    const [safeHtml, setSafeHtml] = useState('');

    useEffect(() => {
        if (!code) {
            setSafeHtml('');
            return;
        }

        const id = Math.random().toString(36).substring(7);

        const handleMessage = (event) => {
            if (event.data.id === id) {
                if (event.data.error) {
                    console.error('Highlight worker error:', event.data.error);
                    // Fallback to basic safe HTML if worker fails
                    setSafeHtml(code.replace(/</g, '&lt;').replace(/>/g, '&gt;'));
                } else {
                    setSafeHtml(DOMPurify.sanitize(event.data.html));
                }
                worker.removeEventListener('message', handleMessage);
            }
        };

        worker.addEventListener('message', handleMessage);
        worker.postMessage({ id, code, type });

        return () => {
            worker.removeEventListener('message', handleMessage);
        };
    }, [code, type]);

    return (
        <code
            className={className}
            dangerouslySetInnerHTML={{ __html: safeHtml || code.replace(/</g, '&lt;').replace(/>/g, '&gt;') }}
        />
    );
};

export default AsyncCodeBlock;
